import * as React from 'react';
import { MainNavigationItem } from './MainNavigationItem';
import { INavigationItem } from '../../interfaces/IHeader';
import * as Colors from '../../consts/variables';
import { HomeIcon } from '../Icons/HomeIcon';
import { SearchIcon } from '../Icons/SearchIcon';
import { ShipIcon } from '../Icons/ShipIcon';
import { DiscountIcon } from '../Icons/DiscountIcon';
import { UserIcon } from '../Icons/UserIcon';
import { WorldIcon } from '../Icons/WorldIcon';
import { AnchorIcon } from '../Icons/AnchorIcon';
import { FaqIcon } from '../Icons/FaqIcon';
import { CompassIcon } from '../Icons/CompassIcon';
import { PackageIcon } from '../Icons/PackageIcon';

interface Props {
    menuItems: INavigationItem[];
    isTopNavigation?: boolean;
}

const homeNavItemStyle: any = {
    border: `1px solid ${Colors.darkGray}`,
    margin: '10px 15px',
};
const wrapperStyle: any = {
    margin: '0px 0 15px',
};
const lastTopNavItemStyle: any = {
    borderBottom: '0',
};

const IconStyle: any = {
    marginRight: '5%',
    fill: Colors.darkAcqa,
    flex: '0 0 auto',
    alignSelf: 'flex-start',
};

const BlankIconStyle: any = {
    marginRight: '5%',
    width: 24,
    height: 24,
};

const iconClasses = [
    { label: 'HomeIcon', icon: HomeIcon, isShownAtCollapsibleSection: false },
    { label: 'SearchIcon', icon: SearchIcon, isShownAtCollapsibleSection: false },
    { label: 'WorldIcon', icon: WorldIcon, isShownAtCollapsibleSection: true },
    { label: 'AnchorIcon', icon: AnchorIcon, isShownAtCollapsibleSection: true },
    { label: 'ShipIcon', icon: ShipIcon, isShownAtCollapsibleSection: true },
    { label: 'CompassIcon', icon: CompassIcon, isShownAtCollapsibleSection: false },
    { label: 'DiscountIcon', icon: DiscountIcon, isShownAtCollapsibleSection: true },
    { label: 'FaqIcon', icon: FaqIcon, isShownAtCollapsibleSection: false },
    { label: 'UserIcon', icon: UserIcon, isShownAtCollapsibleSection: false },
    { label: 'PackageIcon', icon: PackageIcon, isShownAtCollapsibleSection: false },
];

export function MainNavigationMenu({ menuItems, isTopNavigation = true }: Props) {
    const getMainNavigation = () => {
        return menuItems.map((item, index) => {
            const isLastItem = index === menuItems.length - 1;
            const topNavItemStyle: any = isLastItem ? lastTopNavItemStyle : {};
            const Icon = iconClasses.find(iconClass => {
                return iconClass.label === item.icon;
            });
            const MenuIcon =
                Icon && Icon.icon ? (
                    <Icon.icon style={IconStyle} width={24} height={24} />
                ) : (
                    <div style={BlankIconStyle} />
                );
            const showItem = isTopNavigation || (Icon && Icon.isShownAtCollapsibleSection);
            if (showItem) {
                return (
                    <MainNavigationItem
                        key={index}
                        item={item}
                        iconClass={item.icon}
                        itemStyle={isTopNavigation ? topNavItemStyle : homeNavItemStyle}
                        isTopNavigation={isTopNavigation}
                    >
                        {MenuIcon}
                    </MainNavigationItem>
                );
            }
            return null;
        });
    };

    return <ul style={wrapperStyle}>{getMainNavigation()}</ul>;
}
